import React from 'react';
import { Check, Store, Truck, Smartphone, CreditCard } from 'lucide-react';
import { fmtPrice, creditPlan, photoUrl, colorHex } from './utils';

export const ProductCard = ({ p, mall, currency, rate, branch, branches, compared, onCompare, onOpen, onCredit }) => {
  const allowCredit = mall?.vertical_flags?.enable_credit_plans !== false;
  const plan = creditPlan(p.price, mall, 0, p.credit_plan);
  const here = branch ? p.availability.find((a) => a.slug === branch.slug) : p.availability.find((a) => a.stock > 0);
  const store = branches.find((b) => b.slug === here?.slug);
  const img = photoUrl(p);
  return (
    <div className="group rounded-3xl bg-[#1C2541] border border-white/10 overflow-hidden flex flex-col cb-card-hover" data-testid={`product-card-${p.id}`}>
      <button onClick={() => onOpen(p)} className="relative aspect-square bg-gradient-to-b from-[#0F52BA]/30 to-transparent grid place-items-center" data-testid={`product-open-${p.id}`}>
        {img ? <img src={img} alt={p.name} loading="lazy" className="w-full h-full object-contain p-4 group-hover:scale-105 transition-transform duration-500" /> : <Smartphone size={72} className="text-white/20" />}
        {allowCredit && <span className="absolute top-3 left-3 text-[10px] font-black uppercase tracking-widest bg-[#FFC857] text-[#0A192F] px-2 py-1 rounded-full" data-testid="product-card-credit-price">
          {plan.default.n} cuotas de {fmtPrice(plan.default.amount, currency, rate)}
        </span>}
      </button>
      <div className="p-4 flex flex-col flex-1">
        <p className="text-[11px] uppercase tracking-widest text-white/50">{p.marca || p.category}</p>
        <h3 className="cb-display text-2xl text-white leading-tight">{p.name}</h3>
        <div className="flex gap-1.5 mt-2">{(p.specs.colors || []).slice(0, 5).map((c) => <span key={c} title={c} className="w-4 h-4 rounded-full border border-white/30" style={{ background: colorHex(c) }} />)}</div>
        <p className="text-sm text-white/60 mt-2">{[p.specs.ram, p.specs.storage].filter(Boolean).join(' + ')}</p>
        <div className="mt-3">
          <p className="cb-display text-3xl text-white">{fmtPrice(p.price, currency, rate)}</p>
          {allowCredit && <p className="text-xs text-[#FFC857] font-bold">Inicial {fmtPrice(plan.down, currency, rate)} · {plan.default.n} cuotas {plan.default.label}</p>}
        </div>
        <p className={`mt-2 text-xs flex items-center gap-1 ${here?.stock > 0 ? 'text-[#00F2FE]' : 'text-white/50'}`} data-testid={`stock-pill-${p.id}`}>
          {here?.stock > 0 ? <><Store size={13} /> Disponible para retiro hoy en {store?.name || 'tienda'}</> : <><Truck size={13} /> Envío nacional / bajo pedido</>}
        </p>
        <div className="mt-auto pt-4 flex gap-2">
          <button onClick={() => allowCredit ? onCredit(p) : onOpen(p)} className="flex-1 cb-btn-primary !py-2.5 !text-sm" data-testid={`card-credit-${p.id}`}><CreditCard size={15} /> {allowCredit ? 'Crédito' : 'Comprar / Reservar'}</button>
          <button onClick={() => onCompare(p)} title="Comparar" data-testid={`compare-toggle-${p.id}`}
            className={`px-3 rounded-full border text-sm transition-colors ${compared ? 'bg-[#00F2FE] text-[#0A192F] border-[#00F2FE]' : 'border-white/20 text-white/70'}`}>
            {compared ? <Check size={15} /> : 'VS'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
